import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const userSettingsApi = createApi({
    reducerPath: "userSettingsApi",
    tagTypes: ["userSettings"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getUserSettings: build.query({
            query: (data) => ({
                url: api.userSettings.getSettings(data.settingable_id),
                method: "GET",
                params: data,
            }),
            providesTags: (result, error, arg) => [
                { type: "UserSettings", id: arg.settingable_id },
            ],
        }),
        updateUserSettings: build.mutation({
            query: (settings) => ({
                url: api.userSettings.updateSettings(),
                method: "POST",
                body: settings,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "UserSettings", id: arg.settingable_id },
            ],
        }),
    }),
});

export const {
    useLazyGetUserSettingsQuery, useGetUserSettingsQuery, useUpdateUserSettingsMutation
} = userSettingsApi;
